<template>
  <div>

  </div>
</template>

<script>

export default {
  name: "Display_MatchGame_Intro",
  components: {},
  mounted() {
  },
  computed: { },
  methods: {},
  data() {
    return {}
  }
};
</script>

<style lang="scss" scoped>
</style>
